/**
 * Define all the action creators for comoon components
 */
import { ORDERS } from 'src/constants/appConstants';
import {
    GET_DEV_DATA,
    SET_USER_DETAILS,
    SET_IS_AUTHENTICATED_WITH_HYBRIS,
    GET_AUTH_TOKEN,
    GET_HYBRIS_USER_DETAILS,
    LOGIN,
    SET_LOGOUT,
    SET_LOGOUT_SSO,
    CLEAR_SSO_ERROR,
    GET_BANNER_DETAILS,
    GET_BANNER_LENGTH,
    SHOW_DISMISSED_BANNER,
    HIDE_DISMISSED_BANNER,
    SET_BANNER_HEIGHT,
    SET_FORBIDDEN_ERROR_CHECK_VALUE,
    SET_MAST_ORDER,
    SET_BANNER_DETAILS,
    SET_CONFIRMATION_BANNER,
    SET_DESTRUCTIVE,
    HANDLE_EQUITY_NOTES,
    HANDLE_CONSIGNMENT_BILLING_NOTES,
    HANDLE_CONSIGNMENT_ADD_NOTES,
    HANDLE_REPORT_USAGE_NOTES,
    HANDLE_SURGERY_NOTES,
    RESET_NOTES,
    IS_CONDENSED_VIEW,
    IS_HIDE_CONDENSED_VIEW,
    IS_HEADER_CONDENSED_VIEW,
    GET_CONFIGURATION,
    SET_PEDIATRIC_CHECK,
    GET_QR_CODE_REQUEST, 
    CLEAR_QR_CODE,
    SET_QR_GENERATED,
    GET_BATCH_EXPORT_REQUEST,
    CLEAR_BATCH_EXPORT,
    RESET_BANNERS,
} from './constants';

export function getDevData(entityId, entityType) {
    return {
        type: GET_DEV_DATA,
        payload: { entityId, entityType },
    };
}
export function resetBannerData(){
    return{
        type:RESET_BANNERS,
    }
}
export const setUserDetails = (userDetails) => {
    return {
        type: SET_USER_DETAILS,
        payload: userDetails,
    };
};
export const setPediatricCheck = (value) => {
    return {
        type: SET_PEDIATRIC_CHECK,
        payload: value,
    };
};

export const setIsAuthenticatedWithHybris = (authenticated) => {
    return {
        type: SET_IS_AUTHENTICATED_WITH_HYBRIS,
        payload: authenticated,
    };
};

export const getAuthToken = (payload) => {
    return {
        type: GET_AUTH_TOKEN,
        payload: payload,
    };
};

export const getHybrisUserDetails = () => {
    return {
        type: GET_HYBRIS_USER_DETAILS,
    };
};

export const login = (payload) => {
    return {
        type: LOGIN,
        payload,
    };
};

export const getConfigurations = (params, optionChosen) => {
    return {
        type: GET_CONFIGURATION,
        payload: params,
        option: optionChosen,
        orderType: optionChosen === ORDERS ? params.module : null,
    };
};

export const logout = () => {
    return {
        type: SET_LOGOUT,
    };
};

export const logoutSSO = (payload) => {
    return {
        type: SET_LOGOUT_SSO,
        payload: payload,
    };
};
export const clearSsoError = () => {
    return {
        type: CLEAR_SSO_ERROR,
    };
};
export const getBannerDetails = () => {
    return {
        type: GET_BANNER_DETAILS,
    };
};

export const updateBannerLength = (length = 0) => {
    return {
        type: GET_BANNER_LENGTH,
        payload: length,
    };
};

export const showDismissedBanner = () => ({ type: SHOW_DISMISSED_BANNER });

export const hideDismissedBanner = () => ({ type: HIDE_DISMISSED_BANNER });

export const setBannerHeight = (height) => ({
    type: SET_BANNER_HEIGHT,
    payload: height,
});

export const setForbiddenErrorCheckValue = (param) => ({
    type: SET_FORBIDDEN_ERROR_CHECK_VALUE,
    payload: param,
});

export const setIsMastOrder = (value) => {
    return {
        type: SET_MAST_ORDER,
        payload: value,
    };
};
export const setBannerDetails = (data) => ({
    type: SET_BANNER_DETAILS,
    payload: data,
});
export const setConfirmationBanner = (data) => ({
    type: SET_CONFIRMATION_BANNER,
    payload: data,
});

export const setDestructive = (payload) => ({
    type: SET_DESTRUCTIVE,
    payload: payload,
});

//HeaderNotes
export const handleEquityNotes = (data) => {
    return {
        type: HANDLE_EQUITY_NOTES,
        payload: data,
    };
};

export const handleConsignmentBillingNotes = (data) => {
    return {
        type: HANDLE_CONSIGNMENT_BILLING_NOTES,
        payload: data,
    };
};

export const handleConsignmentAddNotes = (data) => {
    return {
        type: HANDLE_CONSIGNMENT_ADD_NOTES,
        payload: data,
    };
};

export const handleReportUsageNotes = (data) => {
    return {
        type: HANDLE_REPORT_USAGE_NOTES,
        payload: data,
    };
};

export const handleSurgeryNotes = (data) => {
    return {
        type: HANDLE_SURGERY_NOTES,
        payload: data,
    };
};

export const resetNotes = () =>{
    return{
        type:RESET_NOTES,
        payload:''
    };
};

export const setIsCondensedView = (data) => {
    return {
        type: IS_CONDENSED_VIEW,
        payload: data,
    };
};

export const setHeaderCondensedView = (data) =>{
    return {
        type: IS_HEADER_CONDENSED_VIEW,
        payload: data,
    };
};

export const setIsHideCondensedView = (data) => {
    return {
        type: IS_HIDE_CONDENSED_VIEW,
        payload: data,
    };
};


export const getQRCodeRequest = (payload) => ({
    type: GET_QR_CODE_REQUEST,
    payload,
});

export const clearQRCode = () => ({
    type: CLEAR_QR_CODE,
});

export const setQrGenerated = (payload) => ({
    type: SET_QR_GENERATED,
    payload,
});

// Batch Export Actions
export const getBatchExportRequest = (payload) => ({
    type: GET_BATCH_EXPORT_REQUEST,
    payload,
});

export const clearBatchExport = () => ({
    type: CLEAR_BATCH_EXPORT,
});
